import { Trans } from "../utils/i18n";
import timezones from "timezones-list";

export const userRegistrationXia = {
    sizes: {
        forth: 3,
        third: 4,
        half: 6,
        full: 12,
    },
    heading: <Trans i18nKey={"auth.register"}>Register</Trans>,
    fields: [
        {
            name: "name",
            label: <Trans i18nKey="auth.register.name">Name</Trans>,
            type: "text",
            required: true,
            variant: "filled",
            style: { marginBottom: "2.5rem" },
        },
        {
            name: "company",
            label: <Trans i18nKey="auth.register.company">Company</Trans>,
            type: "text",
            required: true,
            variant: "filled",
            style: { marginBottom: "2.5rem" },
        },
        {
            name: "email",
            label: <Trans i18nKey="profile.email">E-Mail</Trans>,
            type: "email",
            required: true,
            variant: "filled",
            style: { marginBottom: "2.5rem" },
        },
        {
            name: "password",
            label: <Trans i18nKey="profile.password">Password</Trans>,
            type: "password",
            required: true,
            variant: "filled",
            style: { marginBottom: "2.5rem" },
        },
        {
            name: "password_confirmation",
            label: (
                <Trans i18nKey="profile.confirmPassword">
                    Confirm Password
                </Trans>
            ),
            type: "password",
            required: true,
            variant: "filled",
            style: { marginBottom: "2.5rem" },
        },
        {
            name: "timezone",
            label: <Trans i18nKey="profile.timezone">Timezone</Trans>,
            type: "select",
            required: true,
            variant: "outlined",
            options: timezones.map((item, index) => ({
                key: index,
                value: item.tzCode,
                label: item.tzCode,
            })),
        },
        {
            name: "language",
            label: <Trans i18nKey="profile.language">Language</Trans>,
            type: "select",
            required: true,
            variant: "outlined",
            style: { marginTop: 30 },
            options: [
                {
                    label: <Trans i18nKey="profile.english">English</Trans>,
                    key: "en",
                    value: "en",
                },
                {
                    label: <Trans i18nKey="profile.german">German</Trans>,
                    key: "de",
                    value: "de",
                },
                {
                    label: <Trans i18nKey="profile.french">French</Trans>,
                    key: "fr",
                    value: "fr",
                },
                {
                    label: <Trans i18nKey="profile.spanish">Spanish</Trans>,
                    key: "es",
                    value: "es",
                },
            ],
        },
    ],
};
